import React from 'react';

const KIND_CLS = {
  Content: 'bg-violet-100 text-violet-700',
  Platform: 'bg-blue-100 text-blue-700',
  Delivery: 'bg-emerald-100 text-emerald-700',
};

// Small coloured badge showing which budget a PO belongs to (Content / Delivery / Platform).
export const POKindTag = ({ kind }) => {
  if (!kind) return null;
  return (
    <span
      className={`shrink-0 text-[9px] font-semibold px-1.5 py-0.5 rounded-full uppercase tracking-wide ${KIND_CLS[kind] || 'bg-muted text-muted-foreground'}`}
      data-testid={`po-kind-tag-${kind.toLowerCase()}`}
    >
      {kind}
    </span>
  );
};

export default POKindTag;
